import { useTranslation } from 'react-i18next'

import { AppealTabItem } from 'entities/tour/ui/appeal-details/types.ts'

import { InfoItem } from 'shared/ui/info-item'
import { Paper } from 'shared/ui/paper'

interface Props {
  tabs: AppealTabItem[]
}

export const TourNavigation = ({ tabs }: Props) => {
  const { t } = useTranslation()

  return (
    <Paper padding={[0, 16]}>
      {tabs?.map((tab) => (
        <InfoItem
          key={tab.key}
          title={t(tab.name)}
          subtitle={tab.subtitle}
          icon={tab.icon}
          hasArrow={!!tab.onClick}
          onClick={tab.onClick}
        />
      ))}
    </Paper>
  )
}
